import type * as Types from '../../../graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type TrackSequenceQueryVariables = Types.Exact<{
  contigId: Types.Scalars['Long']['input'];
  rangeStart: Types.Scalars['Int']['input'];
  rangeStop: Types.Scalars['Int']['input'];
}>;


export type TrackSequenceQuery = { genomeViewer: { trackSequence: { sequence: string | null, contig: { id: number, length: number } | null, range: { start: number, stop: number } | null } | null } | null };


export const TrackSequenceDocument = gql`
    query TrackSequence($contigId: Long!, $rangeStart: Int!, $rangeStop: Int!) {
  genomeViewer {
    trackSequence(
      contigId: $contigId
      rangeStart: $rangeStart
      rangeStop: $rangeStop
    ) {
      sequence
      contig {
        id
        length
      }
      range {
        start
        stop
      }
    }
  }
}
    `;

/**
 * __useTrackSequenceQuery__
 *
 * To run a query within a React component, call `useTrackSequenceQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrackSequenceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrackSequenceQuery({
 *   variables: {
 *      contigId: // value for 'contigId'
 *      rangeStart: // value for 'rangeStart'
 *      rangeStop: // value for 'rangeStop'
 *   },
 * });
 */
export function useTrackSequenceQuery(baseOptions: Apollo.QueryHookOptions<TrackSequenceQuery, TrackSequenceQueryVariables> & ({ variables: TrackSequenceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrackSequenceQuery, TrackSequenceQueryVariables>(TrackSequenceDocument, options);
      }
export function useTrackSequenceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrackSequenceQuery, TrackSequenceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrackSequenceQuery, TrackSequenceQueryVariables>(TrackSequenceDocument, options);
        }
export function useTrackSequenceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TrackSequenceQuery, TrackSequenceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrackSequenceQuery, TrackSequenceQueryVariables>(TrackSequenceDocument, options);
        }
export type TrackSequenceQueryHookResult = ReturnType<typeof useTrackSequenceQuery>;
export type TrackSequenceLazyQueryHookResult = ReturnType<typeof useTrackSequenceLazyQuery>;
export type TrackSequenceSuspenseQueryHookResult = ReturnType<typeof useTrackSequenceSuspenseQuery>;
export type TrackSequenceQueryResult = Apollo.QueryResult<TrackSequenceQuery, TrackSequenceQueryVariables>;